export class BlockingLoaderProgress {
    /**
     * Uploading of a file can be a part of a total progress.
     */
    inProgress: boolean;
    /**
     * Upload or download progress in percents.
     */
    percentage: number;
    constructor(inProgress: boolean, progress: number) {
        this.inProgress = inProgress;
        this.percentage = progress;
    }
}
